<h2 mat-dialog-title>{{ tituloTxt }}</h2>
<mat-dialog-content>
    <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
        <input type="hidden" formControlName="id" value="">
          <mat-form-field appearance="outline" class="example-full-width">  
            <mat-label>Nombre contacto</mat-label>
            <input formControlName="contactoNombre" matInput placeholder="Nombre contacto de emergencia" value="">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Telefono contacto</mat-label>
            <input formControlName='contactoTelefono' matInput placeholder="Telefono contacto de emergencia" value="">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Dirección</mat-label>
            <input formControlName='direccion' matInput placeholder="Dirección del deportista" value="">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Teléfono</mat-label>
            <input formControlName='telefono' matInput placeholder="telefono fijo o alternativo del deportista" value="">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>EPS</mat-label>
            <input formControlName='eps' matInput placeholder="EPS del deportista" value="">
            <mat-error>La eps es requerida</mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Fecha de nacimiento</mat-label>
            <input formControlName='fechaNacimiento' type="date" matInput placeholder="Fecha de nacimiento del deportista" value="">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Tipo de sangre</mat-label>
            <mat-select formControlName='rh'>
              <mat-option disabled value=''>Sin datos</mat-option>
              <mat-option value='A+'>A+</mat-option>
              <mat-option value='A-'>A-</mat-option>
              <mat-option value='B+'>B+</mat-option>
              <mat-option value='B-'>B-</mat-option>
              <mat-option value='O+'>O+</mat-option>
              <mat-option value='O-'>O-</mat-option>
              <mat-option value='AB+'>AB+</mat-option>
              <mat-option value='AB-'>AB-</mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Sexo</mat-label>
            <mat-select formControlName='sexo'>
              <mat-option disabled value=''>Sin datos</mat-option>
              <mat-option value='0'>Femenino</mat-option>
              <mat-option value='1'>Masculino</mat-option>
            </mat-select>
          </mat-form-field>
  
            <div class="example-full-width">
              <mat-slide-toggle class="example-margin" formControlName="estado">
                Estado
              </mat-slide-toggle>
            </div> 
        </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button>
    <button mat-button mat-dialog-close='false' >Cancelar</button>
</mat-dialog-actions>
